import axios from "axios";

export default axios.create({

 //baseURL: "http://localhost:5000/api"
 baseURL: "https://p2p-5qd2.onrender.com/api"
  
});

